import { render, staticRenderFns } from "./messageAlert.vue?vue&type=template&id=daff8e9e&scoped=true&"
import script from "./messageAlert.vue?vue&type=script&lang=js&"
export * from "./messageAlert.vue?vue&type=script&lang=js&"
import style0 from "./messageAlert.vue?vue&type=style&index=0&id=daff8e9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daff8e9e",
  null
  
)

export default component.exports